<template>
  <el-form label-position="top" class="passenger-item">
    <el-form-item label="Full Name" :rules="{
      required: true, message: 'Full name is required', trigger: 'blur'
    }">
      <el-input  v-model="model.full_name"/>
    </el-form-item>
    <el-form-item label="Gender" :rules="{
      required: true, message: 'Select a gender', trigger: 'blur'
    }">
      <el-select placeholder="" value="Male" v-model="model.gender" style="display: block">
        <el-option label="Male" value="M"></el-option>
        <el-option label="Female" value="F"></el-option>
      </el-select>
    </el-form-item>
  </el-form>
</template>

<script>
export default {
  name: 'PassengerItem',
  props: ['parent', 'index'],
  data () {
    return {
      model: {
        full_name: '',
        gender: ''
      }
    }
  },
  mounted () {
    this.parent[this.index - 1] = this.model
  }
}
</script>

<style src="./passenger-item.scss" lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/checkout/PassengerItem.vue